
import { showSuccessMessage, showErrorMessage } from "./../utils/alertHelper";

export const handleApiResponse = (response, successMessage, navigateTo, navigate) => {
  if (response.status === true) {
    // Success case
    if (successMessage) {
      showSuccessMessage(successMessage); // Use toast for success message
    }
    if (navigateTo) {
      navigate(navigateTo); // Navigate if a destination is provided
    }
  } else if (response.status === false || response.status === 422) {
    // Handle validation errors or custom errors
    if (response.errors && typeof response.errors === 'object') {
      for (const [field, messages] of Object.entries(response.errors)) {
        // For structured errors like 'items.0.quantity', replace '.' with '_' to match IDs
        const errorField = field.replace(/\./g, '_'); // `items.0.quantity` -> `items_0_quantity`
        const errorElement = document.querySelector(`#${errorField}_error`);

        if (errorElement && Array.isArray(messages) && messages.length > 0) {
          // Display the first error message
          showErrorMessage(messages[0]); // Show the error as a toast
          errorElement.textContent = messages[0]; // Display the error message next to the field
        }
        // error object error display 
        const errorMessage = response.errors.error; // Assuming `error` is the key in the errors object
        showErrorMessage(errorMessage); // Display the error as a toast
      }
    } else if (response.errors && typeof response.errors === 'string') { 
      // Handle custom error messages (e.g., "Refund quantity exceeds available quantity")
      showErrorMessage(response.errors); // Display the error as a toast
      const errorElement = document.querySelector(`#custom_error`);
      if (errorElement) {
        errorElement.textContent = response.errors; // Display the error in a specific element
      }
    } else {
      // If no validation errors exist, or if errors are not structured
      showErrorMessage(response.message || 'An unknown error occurred');
    }
  } else {
    // General error case
    showErrorMessage(response.message || 'An unknown error occurred');
  }



};

